import { isClient as e } from "../server-side/is-client.mjs";
//#region src/white-label-brand/get-brand-from-local-storage.ts
var t = "brand_data", n = () => {
	if (!e()) return;
	let n = localStorage.getItem(t);
	if (n) try {
		return JSON.parse(n);
	} catch {
		return;
	}
};
//#endregion
export { t as LOCAL_STORAGE_BRAND_DATA_ID, n as getBrandFromLocalStorage };
